import { generateAPI } from "../api.generator";
import { Conversation } from "../../types/feedback";

// POST /feedback/mine/read — clears the customer's unread state.
export const markMyConversationRead = generateAPI<
  {},
  Conversation
>("post", "feedback/mine/read");
